// -- redux library --
import axios from 'axios';
import AlertDialog from 'shared/components/molecules/AlertDialog';
import { AxiosErrorType, AxiosRequestType, AxiosResponseType } from 'shared/models/AxiosType';
import { getRefreshToken } from 'shared/utils/else/sessionStorageFunctions';
import { accountsRefreshPostAPI } from 'user/api/accounts';
import { authActions } from 'user/redux/slices/authSlice';
import { systemActions } from 'user/redux/slices/systemSlice';
import { store } from 'user/redux/store';

// -- ready handler --
const onReady = (request: AxiosRequestType, disabled_load = true) => {
  // load処理を無効化できる
  if (!disabled_load) {
    store.dispatch(systemActions.loading(true));
  }
  return request;
};

// -- success handler --
const onSuccess = (response: AxiosResponseType, ended_load = true) => {
  if (ended_load) {
    store.dispatch(systemActions.loading(false));
  }
  return response;
};

// -- error handler --
const onError = (err: AxiosErrorType, disabled_error_message?: boolean) => {
  if (!err) {
    store.dispatch(systemActions.loading(false));
    return;
  }
  if (disabled_error_message) {
    // エラーメッセージをスキップする
    store.dispatch(systemActions.loading(false));
    return err.response;
  }
  console.log(err);
  store.dispatch(systemActions.loading(false));
  switch (err.response.status) {
    case 400: // 入力データに誤りがある場合
      AlertDialog.show('入力データに誤りがあります。');
      break;

    case 401: // ユーザーが認証されていない場合
      return accountsRefreshPostAPI({ refresh_token: getRefreshToken() })
        .then((res) => {
          store.dispatch(authActions.refreshAccessKey({ access_key: res.data.authentication_result.access_token }));

          // 再度リクエスト
          const config = err.config;
          if (typeof config.data === 'string') {
            config.data = JSON.parse(config.data);
          }
          config.headers['x-api-key'] = res.data.authentication_result.access_token;

          return axios.request(config);
        })
        .catch(() => {
          AlertDialog.show('ユーザーが認証されませんでした。再度ログインをしてください。');
          store.dispatch(authActions.signOut());
          return err.response;
        });

    case 404: // 指定したリソースがサーバーに存在しない場合
      AlertDialog.show('指定したリソースはサーバーに存在しません。');
      break;

    case 405: // 指定したリソースのメソッドが許可されていない場合
      AlertDialog.show('指定したリソースのメソッドが許可されていません');
      break;

    case 500: // サーバー内でエラーが発生した場合
      AlertDialog.show('サーバー内で予期せぬエラーが発生しました。');
      break;

    case 502: // サーバーとの通信でエラーが発生した場合
      AlertDialog.show('通信エラーが発生しました。');
      break;

    case 503: // サーバーがアクセス過多で一時的に利用できない時
      AlertDialog.show('アクセス過多によりサービスが一時的に利用できません。数分待ってから再度実行してください。');
      break;

    case 504: // サーバーとの通信がタイムアウトした時
      AlertDialog.show('通信がタイムアウトしました。');
      break;

    default:
      // 予期していないエラー
      AlertDialog.show('予期せぬエラーが発生しました。');
      break;
  }
  return err.response;
};

// -- export part --
export { onReady, onSuccess, onError };
